export default __webpack_public_path__ + "static/Amarberry-eed9355ac7c8786fd2003ab5e3cea171.png";